import React from 'react';
import styled from 'styled-components';
import { ReactComponent as DoctornowLogoText } from '@/assets/images/common/doctornowLogoText.svg';
import { ReactComponent as Close } from '@/assets/images/common/close.svg';
import theme from '@/styles/theme';

interface Props {
  children: React.ReactNode;
}

const NoticeModal = ({ children }: Props) => {
  return (
    <ModalOverlay>
      <ModalWrapper>{children}</ModalWrapper>
    </ModalOverlay>
  );
};

const Header = ({
  logo,
  closeButton,
  onCloseButtonClick
}: {
  logo: boolean;
  closeButton: boolean;
  onCloseButtonClick: () => void;
}) => {
  return (
    <ModalHeader>
      {logo && <DoctornowLogoText width={110} />}
      {closeButton && (
        <CloseButton>
          <Close onClick={onCloseButtonClick} />
        </CloseButton>
      )}
    </ModalHeader>
  );
};

const Content = ({ children }: { children?: React.ReactNode }) => {
  return <ModalContent>{children}</ModalContent>;
};

const Bottom = ({ children }: { children?: React.ReactNode }) => {
  return <ModalBottom>{children}</ModalBottom>;
};

NoticeModal.Header = Header;
NoticeModal.Content = Content;
NoticeModal.Bottom = Bottom;

const ModalOverlay = styled.div`
  box-sizing: border-box;
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
`;

const ModalWrapper = styled.div`
  flex-flow: column;
  background-color: ${theme.DF_COLOR.WHITE};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;

const ModalHeader = styled.div`
  display: flex;
  padding: 20px 25px 10px 20px;
  justify-content: space-between;
  align-items: center;
`;

const ModalContent = styled.div`
  display: inline;
`;

const ModalBottom = styled.div`
  display: flex;
  justify-content: flex-end;
  border-top-color: #efefef;
  border-top-style: solid;
  border-top-width: 1px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

export default NoticeModal;
